import styles from "./NewStandSideBar.module.css";
import arrowWhite from "../../assets/icons/arrow-white.svg";
import arrowGray from "../../assets/icons/Gray-arrow.svg";

export const NEW_STANDARD_MENU_ITEMS = [
  { id: "overview", label: "Overview" },
  { id: "other-editions", label: "Other Editions" },
  { id: "pdss-metadata", label: "PDSS Metadata" },
  { id: "reference-documents", label: "Reference Documents" },
];

export default function NewStandSideBar({
  activeItem = "overview",
  onItemChange,
  title = "Add Standard",
  disabled = false,
}) {
  return (
    <nav className={styles.sideMenu} aria-label="New standard sections">
      <div className={styles.slideTitle}>
        <p>{title}</p>
      </div>

      {NEW_STANDARD_MENU_ITEMS.map(({ id, label }) => {
        const isActive = activeItem === id;
        return (
          <button
            key={id}
            type="button"
            className={`${styles.menuItem} ${isActive ? styles.menuItemActive : ""}`}
            onClick={() => onItemChange?.(id)}
            aria-current={isActive ? "page" : undefined}
            disabled={disabled}
          >
            <span>{label}</span>
            <img
              src={isActive ? arrowWhite : arrowGray}
              alt=""
              aria-hidden="true"
            />
          </button>
        );
      })}
    </nav>
  );
}
